import { AxiosResponse } from "axios";
import { IGetResponse } from "../../../models/Api";
import {
  CreatePriceUnitVariationOpts,
  ListPriceUnitVariationsOpts,
  PriceUnitVariation,
  SetAsDefaultOpts,
  UpdatePriceUnitVariationOpts,
} from "../../../models/Api/PriceUnitVariations";
import { axiosInstance } from "../../../../../axiosInstance";

export interface IListResponse<T> {
  data: {
    items: [T];
    total: number;
    has_more: boolean;
    next_url: string | null;
  };
  success: boolean;
}

export const listPriceUnitVariations = async (
  payload: ListPriceUnitVariationsOpts
): Promise<AxiosResponse<IListResponse<PriceUnitVariation>>> => {
  const params = {
    offset: payload.offset,
    ...(payload.limit && {
      limit: payload.limit,
    }),
  };

  return axiosInstance.get("/price_unit_variations", { params });
};

export const createPriceUnitVariation = async (
  payload: CreatePriceUnitVariationOpts
): Promise<AxiosResponse<IGetResponse<PriceUnitVariation>>> => {
  return axiosInstance.post("/price_unit_variations", payload);
};

export const getPriceUnitVariation = async (
  id: string
): Promise<AxiosResponse<IGetResponse<PriceUnitVariation>>> => {
  return axiosInstance.get(`/price_unit_variations/${id}`);
};

export const updatePriceUnitVariation = async (
  payload: UpdatePriceUnitVariationOpts
): Promise<AxiosResponse<IGetResponse<PriceUnitVariation>>> => {
  const { id, ...params } = payload;

  return axiosInstance.put(`/price_unit_variations/${id}`, params);
};

export const deletePriceUnitVariation = async (
  id: string
): Promise<AxiosResponse<IGetResponse<PriceUnitVariation>>> => {
  return axiosInstance.delete(`/price_unit_variations/${id}`);
};

export const setAsDefault = async (
  payload: SetAsDefaultOpts
): Promise<AxiosResponse<IGetResponse<PriceUnitVariation>>> => {
  const { id } = payload;

  return axiosInstance.post(`/price_unit_variations/${id}/set_as_default`);
};
